import React, { useRef, useEffect, useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane, Button } from "reactstrap";
import classnames from "classnames";
import OrganizationChart from "@dabeng/react-orgchart";
import ScenarioEditorModal from "./ScenarioEditorModal";
import { nodeTreeJson, selectFilter } from "./nodeUserFunctions";
import { Link } from "react-router-dom";
import SceneGenNavbar from "./SceneGenNavbar";
import Select from "react-select";
import "./full-view.css";

const options = [
  { value: 'AEB', label: 'AEB' },
  { value: 'ACC', label: 'ACC' },
  { value: 'LKA', label: 'LKA' },
  { value: 'TSR', label: 'TSR' },
  { value: 'LCA', label: 'LCA' },
  { value: 'Custom Search ...', label: 'Custom Search ...' }
];

const ScenarioEditor = () => {
  const orgchart = useRef();
  const datasource = useRef({});
  const [ds, setDS] = useState(datasource.current);

  const [selectedNodes, setSelectedNodes] = useState(new Set());
  // const [setNewNodes] = useState([{ name: "", title: "" }]);
  const [isMultipleSelect] = useState(false);
  const [filename, setFilename] = useState("master_strategy");
  const [fileextension, setFileextension] = useState("png");
  const [componentStatus, setComponentStatus] = useState(false);
  const [activeTab, setActiveTab] = useState("export");
  const [showpopup, setShowpopup] = useState(false);
  const [zoom, setZoom] = useState(100);
  const [view, setView] = useState(false);
  const [ loading,setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [filter, setFilter] = useState(false);
  const [hidden, setHidden] = useState(true);

  let zoomButton = document.getElementsByClassName("orgchart");
  let content = document.getElementsByClassName("oc-content");


  useEffect(() => {
    nodeTreeJson(`${window.location.origin}/scenario_editor_json`).then(
      (response) => {
        if (response && response.status === 200) {
          datasource.current = response.data; //replaced datasource by datasource.current
          // console.log(response.data)
          setDS(datasource.current);
        }
      }
    );
  }, []);

  const readSelectedNode = (nodeData) => {
    if (isMultipleSelect) {
      setSelectedNodes((prev) => new Set(prev.add(nodeData)));
    } else {
      setSelectedNodes(new Set([nodeData]));
    }
    setShowpopup(true);
  };

  const clearSelectedNode = () => {
    setSelectedNodes(new Set());
  };
  // const options = [
  //   { value: 'AEB', label: 'AEB' },
  //   { value: 'ACC', label: 'ACC' },
  //   { value: 'LKA', label: 'LKA' },
  //   { value: 'TSR', label: 'TSR' },
  //   { value: 'LCA', label: 'LCA' },
  //   { value: 'Custom Search ...', label: 'Custom Search ...' }
  // ];

  // const ScenarioEditor = () => {
  //   const orgchart = useRef();
  //   let datasource = {};
  //   const [ds, setDS] = useState(datasource);

  //   const [selectedNodes, setSelectedNodes] = useState(new Set());
  //   const [setNewNodes] = useState([{ name: "", title: "" }]);
  //   const [isMultipleSelect] = useState(false);
  //   const [filename, setFilename] = useState("master_strategy");
  //   const [fileextension, setFileextension] = useState("png");
  //   const [componentStatus, setComponentStatus] = useState(false);
  //   const [activeTab, setActiveTab] = useState("export");
  //   const [showpopup, setShowpopup] = useState(false);
  //   const [zoom, setZoom] = useState(100);
  //   const [view, setView] = useState(false);
  //   const [setLoading] = useState(false);
  //   const [selectedOption, setSelectedOption] = useState(null);
  //   const [filter, setFilter] = useState(false);
  //   const [hidden, setHidden] = useState(true);

  //   let zoomButton = document.getElementsByClassName("orgchart");
  //   let content = document.getElementsByClassName("oc-content");


  //   useEffect(() => {
  //     nodeTreeJson(`${window.location.origin}/scenario_editor_json`).then(
  //       (response) => {
  //         if (response && response.status === 200) {
  //           datasource = response.data;
  //           console.log(response.data)
  //           setDS(datasource);
  //         }
  //       }
  //     );
  //   }, []);

  //   const readSelectedNode = (nodeData) => {
  //     if (isMultipleSelect) {
  //       setSelectedNodes((prev) => new Set(prev.add(nodeData)));
  //     } else {
  //       setSelectedNodes(new Set([nodeData]));
  //     }
  //     setShowpopup(true);
  //   };

  //   const clearSelectedNode = () => {
  //     setSelectedNodes(new Set());
  //   };

  //  const removeNewNode = (index) => {
  //    setNewNodes((prevNewNodes) => {
  //      prevNewNodes.splice(index, 1);
  //      return [...prevNewNodes];
  //    });
  //  };

  //  const onMultipleSelectChange = (e) => {
  //    setIsMultipleSelect(e.target.checked);
  //  };

  const exportTo = () => {
    orgchart.current.exportTo(filename, fileextension);
  };

  const onFileNameChange = (event) => {
    setFilename(event.target.value);
  };

  const onExtensionChange = (event) => {
    setFileextension(event.target.value);
  };

  const onComponentStatus = () => {
    setComponentStatus(!componentStatus);
  };

  const onZoomIn = () => {
    if (zoom < 165) {
      setZoom(zoom + 5);
      zoomButton[0].style.zoom = `${zoom + 5}%`;
    }
  };

  const onZoomOut = () => {
    if (zoom > 60) {
      setZoom(zoom - 5);
      zoomButton[0].style.zoom = `${zoom - 5}%`;
    }
  };

  const onZoomReset = () => {
    setZoom(100);
    zoomButton[0].style.zoom = `${100}%`;
  };

  const onActiveTab = (activeTab) => {
    setActiveTab(activeTab);
  };

  const togglePopup = () => {
    setShowpopup(false);
  };

  const fullView = () => {
    for (let i = 0; i < content.length; i++) {
      content[i].style.height = "20px";
    }
  };

  const partialView = () => {
    for (let i = 0; i < content.length; i++) {
      content[i].style.height = "0px";
    }
  };

  const toggle = () => {
    view ? fullView() : partialView();
    setView(!view);
  };

  const onSelect = (e) => {
    // console.log(e)
    
    setLoading(true)
    console.log(loading)
    if (e !== null) {
      selectFilter([e.value], `${window.location.origin}/selectedFilter`).then(
        (response) => {
          if (response && response.status === 200) {
            datasource.current = response.data;
            // console.log(response.data)
            setDS(datasource.current);
            setFilter(true)
            setHidden(false)
            view ? partialView() : fullView()
          }
          setLoading(false)
        }
      );
    } else {
      nodeTreeJson(`${window.location.origin}/scenario_editor_json`).then(
        (response) => {
          if (response && response.status === 200) {
            datasource.current = response.data;
            // console.log(response.data)
            setDS(datasource.current);
            setFilter(false)
            setHidden(true)
            view ? partialView() : fullView()
          }
          setLoading(false)
        }
      );
    }
    setSelectedOption(e)
  };
  // console.log(Select)
  return (
    <div data-test = 'sceneExtractscenarioEditorComponent' id="purple-background" style={{ width: "100%" }}>
      <SceneGenNavbar />
      <div className="container-fluid">
        <div className="row">
          <div className="col mt-5 mx-auto">
            <div className="card">
              <div className="card-header">
                <div className="row mt-2">
                  <div className="col-md-4">
                    <Select
                      className="basic-single"
                      classNamePrefix="select filter"
                      defaultValue={selectedOption}
                      isClearable={true}
                      isSearchable={true}
                      name="color"
                      onChange={(e) => onSelect(e)}
                      options={options}
                    />
                  </div>
                  <div className="col-md-3 text-center">
                    <h2>Master Strategy</h2>
                  </div>
                  <div className="col-md-5 text-right">
                    <Link
                      to="/view_valid_scene_data"
                      style={{ textDecoration: "none", color: view ? "#464646" : "#FFFFFF" }}
                    >
                      <Button
                        style={{
                          marginLeft: "0.1rem",
                          border: "0px",
                          backgroundColor: view ? "#abec5b" : "#9296ff",
                          width: "40%"
                        }}
                        hidden={hidden}
                      >
                        Scenario Listing
                    </Button>
                    </Link>
                    <Button
                      onClick={toggle}
                      style={{
                        marginLeft: "0.1rem",
                        border: "0px",
                        color: view ? "#464646" : "#FFFFFF",
                        backgroundColor: view ? "#abec5b" : "#9296ff",
                      }}
                    >
                      {view ? "Comfort" : "Compact"}
                    </Button>
                    <Button
                      style={{
                        marginLeft: "0.1rem",
                        border: "0px",
                        color: view ? "#464646" : "#FFFFFF",
                        backgroundColor: view ? "#abec5b" : "#9296ff",
                      }}
                      onClick={() => onZoomReset()}
                    >
                      <i className="fas fa-recycle" />
                    </Button>
                    <Button
                      style={{
                        marginLeft: "0.1rem",
                        border: "0px",
                        color: view ? "#464646" : "#FFFFFF",
                        backgroundColor: view ? "#abec5b" : "#9296ff",
                      }}
                      onClick={() => onZoomIn()}
                    >
                      <i className="fas fa-search-plus" />
                    </Button>
                    <Button
                      style={{
                        marginLeft: "0.1rem",
                        border: "0px",
                        color: view ? "#464646" : "#FFFFFF",
                        backgroundColor: view ? "#abec5b" : "#9296ff",
                      }}
                      onClick={() => onZoomOut()}
                    >
                      <i className="fas fa-search-minus" />
                    </Button>
                    <Button
                      className="btn"
                      data-toggle="collapse"
                      data-target="#components-card"
                      aria-controls="components-card"
                      onClick={() => onComponentStatus()}
                      style={{
                        marginLeft: "0.1rem",
                        border: "0px",
                        color: view ? "#464646" : "#FFFFFF",
                        backgroundColor: view ? "#abec5b" : "#9296ff",
                      }}
                    >
                      <i
                        className={
                          componentStatus
                            ? "fa fa-angle-double-up"
                            : "fa fa-angle-double-down"
                        }
                      />
                    </Button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="collapse" id="components-card">
                    <div className="card card-body">
                      <div className="row">
                        <div className="col-md-12">
                          <Nav tabs>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: activeTab === "export",
                                })}
                                onClick={() => onActiveTab("export")}
                              >
                                Export
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent activeTab={activeTab}>
                            <TabPane tabId="export">
                              <div className="card card-body mt-2">
                                <div className="row">
                                  <div className="col-md-12">
                                    <div
                                      className="card card-body"
                                      style={{ border: "0px" }}
                                    >
                                      <section className="toolbar">
                                        <label htmlFor="txt-filename">
                                          Filename:
                                        </label>
                                        <input
                                          id="txt-filename"
                                          type="text"
                                          value={filename}
                                          onChange={onFileNameChange}
                                          style={{
                                            fontSize: "1rem",
                                            marginRight: "2rem",
                                          }}
                                        />
                                        <span>Fileextension: </span>
                                        <input
                                          id="rd-png"
                                          type="radio"
                                          value="png"
                                          checked={fileextension === "png"}
                                          onChange={onExtensionChange}
                                        />
                                        <label htmlFor="rd-png">png</label>
                                        <input
                                          style={{ marginLeft: "1rem" }}
                                          id="rd-pdf"
                                          type="radio"
                                          value="pdf"
                                          checked={fileextension === "pdf"}
                                          onChange={onExtensionChange}
                                        />
                                        <label htmlFor="rd-pdf">pdf</label>
                                        <Button
                                          onClick={exportTo}
                                          style={{
                                            marginLeft: "2rem",
                                            backgroundColor: "#753DFF",
                                          }}
                                        >
                                          Export
                                        </Button>
                                      </section>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card" style={{ border: "0px", padding: "0px" }}>
          <div
            className="card-header"
            style={{ color: "white", padding: "0px" }}
          >
            <OrganizationChart
              ref={orgchart}
              datasource={ds}
              collapsible={true}
              multipleSelect={isMultipleSelect}
              onClickNode={readSelectedNode}
              onClickChart={clearSelectedNode}
              draggable={true}
              style={{ height: "0px" }}
            />
          </div>
        </div>
        {showpopup ? (
          <ScenarioEditorModal
            editSelectedRow={showpopup}
            handleEditModalClose={togglePopup}
            content={selectedNodes}
            datasource={ds}
            filter={filter}
          />
        ) : undefined}
      </div>
    </div>
  );
};

export default ScenarioEditor;

